const stickyUrlByKey = new Map<string, string>();

export function mediaObjectKey(url: string): string {
  try {
    const parsed = new URL(url);
    return `${parsed.origin}${parsed.pathname}`;
  } catch {
    return url;
  }
}

export function preferStableMediaUrl(current: string | null, next: string | null): string | null {
  if (!next) return null;
  if (!current) return next;
  return mediaObjectKey(current) === mediaObjectKey(next) ? current : next;
}

/** Keep the first signed URL for a storage object so the image is not re-fetched on every API refresh. */
export function stickyMediaUrl(cacheKey: string, next: string | null): string | null {
  if (!next) {
    stickyUrlByKey.delete(cacheKey);
    return null;
  }
  const stable = preferStableMediaUrl(stickyUrlByKey.get(cacheKey) ?? null, next) ?? next;
  stickyUrlByKey.set(cacheKey, stable);
  return stable;
}
